<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-attendance
            :resources="resources"
            @updateDate="changeDate"
          ></list-attendance>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import ListAttendance from "../../Components/Attendance/ListAttendance.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import moment from "moment";

export default {
  components: {
    BaseLayout,
    ListAttendance,
    IonGrid,
    IonRow,
    IonCol,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Attendence",
      backLink: "dashboard",
      reloadable: true,
      date: moment().format("YYYY-MM-DD"),
    };
  },

  computed: {
    resources() {
      return this.$store.getters["attendance/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = true) {
      await this.$store.dispatch("attendance/resources", {
        refresh: refresh,
        attendance_date: this.date,
      });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("attendance/resources", {
        attendance_date: this.date,
        refresh: true,
      });
      if (event) {
        event.target.complete();
      }
    },
    changeDate(date) {
      this.date = moment(date).format("YYYY-MM-DD");
      this.refresh();
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
